<div class="spinner-container">
    <div>
      <!-- <mat-progress-spinner color="primary" mode="indeterminate" diameter="60" strokeWidth="8">
      </mat-progress-spinner> -->
      <mat-spinner></mat-spinner>
    </div>

  </div>
